import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./SwipeableList.css";
import AddItemListComponent from "../AddItemListComponent/AddItemListComponent";
import { addCustomItemToInventory } from "../../../Actions/inventoryActions";
import { addCustomItemToShopping } from "../../../Actions/shoppingActions";
import { fetchItem, clearFetchedItem } from "../../../Actions/apiActions";
import { setEditItemState } from "../../../Actions/inventoryActions";
import orderList from "../../../Utilities/orderList";

let langData = require("../../../Data/language.json");

class SwipeableList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      selectedSort: "date newest",
    };
  }

  currentOpenItem = null;
  childrenWithProps = null;

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.collapseAllExcept(this.currentOpenItem);
    }
  }

  componentDidMount() {
    let currentOrder = this.props.listOrder;
    this.setState({ selectedSort: currentOrder });
  }

  collapseAll = () => {
    this.currentOpenItem = null;

    this.childrenWithProps = React.Children.map(
      this.props.children,
      (child) => {
        if (!child.props.background) {
          return React.cloneElement(child, {
            background: this.props.background,
            language: this.props.language,
            currentScreen: this.props.currentScreen,
            collapseAllExcept: this.collapseAllExcept,
            expanded: false,
            collapseAll: this.collapseAll,
            toggleEditState: this.toggleEditing,
          });
        }
        return React.cloneElement(child, {
          language: this.props.language,
          currentScreen: this.props.currentScreen,
          collapseAllExcept: this.collapseAllExcept,
          expanded: false,
          collapseAll: this.collapseAll,
          toggleEditState: this.toggleEditing,
        });
      }
    );

    this.forceUpdate();
  };

  collapseAllExcept = (key) => {
    if (this.props.children.key !== null) {
      this.props.children.forEach((elem) => {
        if (elem.key === key) {
          this.currentOpenItem = key;
        }
      });
    }
    this.childrenWithProps = React.Children.map(
      this.props.children,
      (child) => {
        if (child.key === null) {
          return child;
        } else {
          if (child.key === this.currentOpenItem) {
            if (!child.props.background) {
              return React.cloneElement(child, {
                background: this.props.background,
                language: this.props.language,
                currentScreen: this.props.currentScreen,
                collapseAllExcept: this.collapseAllExcept,
                expanded: true,
                collapseAll: this.collapseAll,
                toggleEditState: this.toggleEditing,
              });
            }
            return React.cloneElement(child, {
              language: this.props.language,
              currentScreen: this.props.currentScreen,
              collapseAllExcept: this.collapseAllExcept,
              expanded: true,
              collapseAll: this.collapseAll,
              toggleEditState: this.toggleEditing,
            });
          } else {
            if (!child.props.background) {
              return React.cloneElement(child, {
                background: this.props.background,
                language: this.props.language,
                currentScreen: this.props.currentScreen,
                collapseAllExcept: this.collapseAllExcept,
                expanded: false,
                collapseAll: this.collapseAll,
                toggleEditState: this.toggleEditing,
              });
            }
            return React.cloneElement(child, {
              language: this.props.language,
              currentScreen: this.props.currentScreen,
              collapseAllExcept: this.collapseAllExcept,
              expanded: false,
              collapseAll: this.collapseAll,
              toggleEditState: this.toggleEditing,
            });
          }
        }
      }
    );
    this.forceUpdate();
  };

  toggleEditing = () => {
    if (this.props.editingState) {
      this.props.setEditItemState(false);
    } else {
      this.props.setEditItemState(true);
    }
  };

  selectSort = (sorting) => {
    let currentScreen = this.props.currentScreen;
    let currentList = [];

    if (currentScreen === "inventory") {
      currentList = this.props.inventory;
    } else if (currentScreen === "trash") {
      currentList = this.props.trash;
    } else {
      currentList = currentList = this.props.shopping;
    }

    if (sorting === "date") {
      if (this.state.selectedSort === "date newest") {
        this.setState({ selectedSort: "date oldest" });
        orderList(currentList, "date oldest", currentScreen);
      } else {
        this.setState({ selectedSort: "date newest" });
        orderList(currentList, "date newest", currentScreen);
      }
    } else if (sorting === "name") {
      if (this.state.selectedSort === "name asc") {
        this.setState({ selectedSort: "name desc" });
        orderList(currentList, "name desc", currentScreen);
      } else {
        this.setState({ selectedSort: "name asc" });
        orderList(currentList, "name asc", currentScreen);
      }
    } else if (sorting === "qty") {
      if (this.state.selectedSort === "qty asc") {
        this.setState({ selectedSort: "qty desc" });
        orderList(currentList, "qty desc", currentScreen);
      } else {
        this.setState({ selectedSort: "qty asc" });
        orderList(currentList, "qty asc", currentScreen);
      }
    }
  };

  render() {
    /*------------------------- SORTING CODE ------------------------- */
    var dateStyle = {};
    var nameStyle = {};
    var qtyStyle = {};
    var nameTitle = langData[this.props.language].list.titles.name;
    var addedTitle = langData[this.props.language].list.titles.added;
    var qtyTitle = langData[this.props.language].list.titles.quantity;

    if (this.state.selectedSort === "date newest") {
      dateStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      addedTitle = (
        <p style={{ marginBottom: "0px" }}>
          {langData[this.props.language].list.titles.added} &#9662;
        </p>
      );
    } else if (this.state.selectedSort === "date oldest") {
      dateStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      addedTitle = (
        <p style={{ marginBottom: "0px" }}>
          {langData[this.props.language].list.titles.added} &#9652;
        </p>
      );
    } else if (this.state.selectedSort === "name asc") {
      nameStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      nameTitle = (
        <p style={{ marginBottom: "0px" }}>
          {" "}
          {langData[this.props.language].list.titles.name} &#9662;{" "}
        </p>
      );
    } else if (this.state.selectedSort === "name desc") {
      nameStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      nameTitle = (
        <p style={{ marginBottom: "0px" }}>
          {" "}
          {langData[this.props.language].list.titles.name} &#9652;{" "}
        </p>
      );
    } else if (this.state.selectedSort === "qty asc") {
      qtyStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      qtyTitle = (
        <p style={{ marginBottom: "0px" }}>
          {" "}
          {langData[this.props.language].list.titles.quantity} &#9662;{" "}
        </p>
      );
    } else if (this.state.selectedSort === "qty desc") {
      qtyStyle = {
        fontWeight: "800",
        textDecoration: "underline",
      };
      qtyTitle = (
        <p style={{ marginBottom: "0px" }}>
          {langData[this.props.language].list.titles.quantity} &#9652;{" "}
        </p>
      );
    }

    /*-------------------------  EMPTY LIST CODE ------------------------- */
    var emptyContent = null;

    if (
      this.childrenWithProps !== null &&
      this.childrenWithProps.length === 0 &&
      this.props.listenerActive
    ) {
      if (this.props.currentScreen === "shopping") {
        emptyContent = (
          <div className="container-fluid col-10 emptyIconWrapper">
            <img
              className="emptyIcon"
              src={require("../../../Images/emptyLists/emptyShopping.svg")}
              alt="emptyShoppingIcon"
            ></img>
            <h6 className="emptyListTxt">
              {langData[this.props.language].shopping.empty}
            </h6>
          </div>
        );
      } else if (this.props.currentScreen === "inventory") {
        emptyContent = (
          <div className="container-fluid col-10 emptyIconWrapper">
            <img
              className="emptyIcon"
              src={require("../../../Images/emptyLists/emptyInventory.svg")}
              alt="emptyInventoryIcon"
            ></img>
            <h6 className="emptyListTxt">
              {langData[this.props.language].inventory.empty}
            </h6>
          </div>
        );
      } else {
        emptyContent = (
          <div className="container-fluid col-10 emptyIconWrapper">
            <img
              className="emptyIcon"
              src={require("../../../Images/emptyLists/emptyTrash.svg")}
              alt="emptyTrashIcon"
            ></img>
            <h6 className="emptyListTxt">
              {langData[this.props.language].trash.empty}
            </h6>
          </div>
        );
      }
    }

    const { children } = this.props;

    let AddItemToListComponent = null;
    if (this.props.currentScreen === "inventory") {
      AddItemToListComponent = (
        <AddItemListComponent
          fetchingStatus={this.props.fetchingStatus}
          fetchEAN={(EAN) => {
            this.props.fetchItem(EAN);
          }}
          onAdd={this.props.addInvItem}
          user={this.props.username}
          fetchedItem={this.props.fetchedItem}
          language={this.props.language}
          clearFetchedItem={this.props.clearFetchedItem}
        />
      );
    } else if (this.props.currentScreen === "shopping") {
      AddItemToListComponent = (
        <AddItemListComponent
          fetchingStatus={this.props.fetchingStatus}
          fetchEAN={(EAN) => {
            this.props.fetchItem(EAN);
          }}
          onAdd={this.props.addShopItem}
          user={this.props.username}
          fetchedItem={this.props.fetchedItem}
          language={this.props.language}
          clearFetchedItem={this.props.clearFetchedItem}
        />
      );
    }

    if (this.childrenWithProps === null) {
      this.childrenWithProps = React.Children.map(children, (child) => {
        if (children.key === null) {
          return child;
        } else if (!child.props.background) {
          return React.cloneElement(child, {
            background: this.props.background,
            language: this.props.language,
            currentScreen: this.props.currentScreen,
            collapseAllExcept: this.collapseAllExcept,
            expanded: false,
            collapseAll: this.collapseAll,
            toggleEditState: this.toggleEditing,
            editing: this.state.editing,
          });
        } else {
          return React.cloneElement(child, {
            language: this.props.language,
            currentScreen: this.props.currentScreen,
            collapseAllExcept: this.collapseAllExcept,
            expanded: false,
            collapseAll: this.collapseAll,
            toggleEditState: this.toggleEditing,
            editing: this.state.editing,
          });
        }
      });
    }

    let listContent = (
      <div className="List">
        {this.childrenWithProps}
        {this.props.uncatContent}
      </div>
    );

    return (
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="row listHeader">
          <div
            className="container col-5 listTitle"
            style={nameStyle}
            onClick={() => this.selectSort("name")}
          >
            {nameTitle}
          </div>
          <div
            className="container col-1 listQuantityTitle"
            style={qtyStyle}
            onClick={() => this.selectSort("qty")}
          >
            {qtyTitle}
          </div>
          <div
            className="container col-2 listTitle"
            style={dateStyle}
            onClick={() => this.selectSort("date")}
          >
            {addedTitle}
          </div>
          <div className="container col-2 listTitle d-none d-sm-block">
            {langData[this.props.language].list.titles.comment}
          </div>
          <div className="container col-2 listTitle">
            {langData[this.props.language].list.titles.add}
          </div>
        </div>
        {AddItemToListComponent}
        <div className="container col-12 categoryRow">
          <h6
            style={{
              marginLeft: "4px",
              marginBottom: "0px",
              fontWeight: "400",
              fontSize: "12pt",
            }}
          >
            {langData[this.props.language].list.functions.category}{" "}
            {
              langData[this.props.language].list.functions.filterOptions[
                this.props.category
              ]
            }
          </h6>
        </div>
        {emptyContent}
        {this.props.listenerActive ? (
          listContent
        ) : (
          <div className="container-fluid loaderContainer col-6">
            <div className="loader"></div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.firebase.username,
  language: state.firebase.language,
  currentScreen: state.mainScreen.mainScreenMode,
  fetchedItem: state.apiInfo.fetchedItem,
  fetchingStatus: state.apiInfo.fetching,
  editingState: state.firebase.editingItem,
  inventory: state.firebase.inventory,
  trash: state.firebase.trash,
  shopping: state.firebase.shopping,
  listOrder: state.firebase.listOrder,
  category: state.firebase.category,
  listenerActive: state.firebase.listenerActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addShopItem: (
      user,
      name,
      comment,
      quantity,
      fetchEAN,
      fullname,
      size,
      unit_id,
      dep_id,
      dep_name,
      cat_id,
      cat_name,
      subcat_id,
      subcat_name,
      image,
      carbon_fp,
      water_fp,
      nutrients,
      average_price
    ) =>
      dispatch(
        addCustomItemToShopping(
          user,
          name,
          comment,
          quantity,
          fetchEAN,
          fullname,
          size,
          unit_id,
          dep_id,
          dep_name,
          cat_id,
          cat_name,
          subcat_id,
          subcat_name,
          image,
          carbon_fp,
          water_fp,
          nutrients,
          average_price
        )
      ),
    addInvItem: (
      user,
      name,
      comment,
      quantity,
      fetchEAN,
      fullname,
      size,
      unit_id,
      dep_id,
      dep_name,
      cat_id,
      cat_name,
      subcat_id,
      subcat_name,
      image,
      carbon_fp,
      water_fp,
      nutrients,
      average_price
    ) =>
      dispatch(
        addCustomItemToInventory(
          user,
          name,
          comment,
          quantity,
          fetchEAN,
          fullname,
          size,
          unit_id,
          dep_id,
          dep_name,
          cat_id,
          cat_name,
          subcat_id,
          subcat_name,
          image,
          carbon_fp,
          water_fp,
          nutrients,
          average_price
        )
      ),
    fetchItem: (EAN) => dispatch(fetchItem(EAN)),
    clearFetchedItem: () => dispatch(clearFetchedItem()),
    setEditItemState: (newState) => dispatch(setEditItemState(newState)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SwipeableList)
);
